export default __webpack_public_path__ + "img/colored-check.d33fbd2b.svg";